module.exports = __webpack_public_path__ + "img/avatar.37c14bd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/assistant/avatar.png
// module id = ./assets/assistant/avatar.png
// module chunks = 10